var _path, _path2, _circle, _circle2, _circle3, _circle4, _path3, _path4, _circle5, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,11H7c-2.2091,0-4,1.7909-4,4v13c0,2.2091,1.7909,4,4,4h9.0159c.6135,0,1.2123,.1881,1.7156,.5389l9.2686,6.4611-4-7h2c2.2091,0,4-1.7909,4-4V15c0-2.2091-1.7909-4-4-4Z",
    fill: "#b2ddc9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27,40c-.1992,0-.3994-.0596-.5723-.1797l-9.2686-6.4609c-.3369-.2354-.7324-.3594-1.1436-.3594H7c-2.7568,0-5-2.2432-5-5V15c0-2.7568,2.2432-5,5-5H25c2.7568,0,5,2.2432,5,5v13c0,2.7568-2.2432,5-5,5h-.2764l3.1445,5.5039c.2324,.4062,.1514,.9189-.1934,1.2344-.1895,.1729-.4316,.2617-.6748,.2617ZM7,12c-1.6543,0-3,1.3457-3,3v13c0,1.6543,1.3457,3,3,3h9.0156c.8223,0,1.6133,.248,2.2881,.7188l5.624,3.9209-1.7959-3.1436c-.1768-.3096-.1758-.6895,.0029-.998,.1797-.3086,.5088-.498,.8652-.498h2c1.6543,0,3-1.3457,3-3V15c0-1.6543-1.3457-3-3-3H7Z",
    fill: "#497ca6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 1,
    fill: "#497ca6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 22,
    r: 1,
    fill: "#497ca6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 22,
    r: 1,
    fill: "#497ca6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 22,
    r: 1,
    fill: "#497ca6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39,13h18c2.2091,0,4,1.7909,4,4v13c0,2.2091-1.7909,4-4,4h-9.0159c-.6135,0-1.2123,.1881-1.7156,.5389l-9.2686,6.4611,4-7h-2c-2.2091,0-4-1.7909-4-4v-13c0-2.2091,1.7909-4,4-4Z",
    fill: "#b2ddc9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37,42c-.2432,0-.4854-.0889-.6748-.2617-.3447-.3154-.4258-.8281-.1934-1.2344l3.1445-5.5039h-.2764c-2.7568,0-5-2.2432-5-5v-13c0-2.7568,2.2432-5,5-5h18c2.7568,0,5,2.2432,5,5v13c0,2.7568-2.2432,5-5,5h-9.0156c-.4111,0-.8066,.124-1.1436,.3594l-9.2686,6.4609c-.1729,.1201-.373,.1797-.5723,.1797Zm2-28c-1.6543,0-3,1.3457-3,3v13c0,1.6543,1.3457,3,3,3h2c.3564,0,.6855,.1895,.8652,.498,.1787,.3086,.1797,.6885,.0029,.998l-1.7959,3.1436,5.624-3.9209c.6748-.4707,1.4658-.7188,2.2881-.7188h9.0156c1.6543,0,3-1.3457,3-3v-13c0-1.6543-1.3457-3-3-3h-18Z",
    fill: "#497ca6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 30,
    r: 1,
    fill: "#497ca6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48,28c-.5527,0-1-.4473-1-1v-1.7432c0-1.4932,.752-2.8359,1.9639-3.5039,.7617-.4199,1.1553-1.2539,1.0029-2.124-.1377-.7861-.8096-1.458-1.5957-1.5957-.6094-.1084-1.1963,.0469-1.6562,.4346-.4541,.3809-.7148,.9395-.7148,1.5322,0,.5527-.4473,1-1,1s-1-.4473-1-1c0-1.1846,.5205-2.3018,1.4287-3.0645,.9072-.7617,2.1016-1.0781,3.2881-.873,1.6123,.2842,2.9365,1.6084,3.2207,3.2207,.2969,1.6982-.5098,3.3945-2.0078,4.2217-.5654,.3105-.9297,.999-.9297,1.752v1.7432c0,.5527-.4473,1-1,1Z",
    fill: "#497ca6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40,54c-.2559,0-.5117-.0977-.707-.293-.3906-.3906-.3906-1.0234,0-1.4141l1.293-1.293H21c-.5527,0-1-.4473-1-1s.4473-1,1-1h22c.4043,0,.7695,.2432,.9238,.6172,.1553,.374,.0693,.8037-.2168,1.0898l-3,3c-.1953,.1953-.4512,.293-.707,.293Z",
    fill: "#497ca6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43,47H21c-.4043,0-.7695-.2432-.9238-.6172-.1553-.374-.0693-.8037,.2168-1.0898l3-3c.3906-.3906,1.0234-.3906,1.4141,0s.3906,1.0234,0,1.4141l-1.293,1.293h19.5859c.5527,0,1,.4473,1,1s-.4473,1-1,1Z",
    fill: "#497ca6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.818d0fe06e70113b3b250fc8969c081d.svg";
export { ForwardRef as ReactComponent };